import { useMediaQuery } from '@mantine/hooks'

export function useDevice() {
  const isMobile = useMediaQuery('(max-width: 860px)')
  return { isMobile }
}
